import { Button, Flex, Modal, Transfer, List, Checkbox, Tag } from 'antd';
import { useState, useEffect } from 'react';
import { PlusOutlined, MinusOutlined, CloseOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { isArray, isString } from 'lodash-es';

interface RecordType {
  key: string;
  title: string;
}

interface CustomModalSelectProps {
  value?: any[];
  label?: string;
  onChange?: (value: any[]) => void;
  dataSource?: RecordType[];
}

const CustomModalSelect = ({
  value,
  onChange,
  dataSource,
  label,
}: CustomModalSelectProps) => {
  const { t } = useTranslation();
  const [values, setValues] = useState<any[]>(value || []);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [mockData, setMockData] = useState<RecordType[]>([]);
  const [targetKeys, setTargetKeys] = useState<React.Key[]>([]);

  useEffect(() => {
    const newMockData: any[] = [];
    if (dataSource && isArray(dataSource)) {
      dataSource.forEach((item) => {
        newMockData.push({
          key: item,
          title: item,
        });
      });
    }
    setMockData(newMockData);
  }, [dataSource]);

  useEffect(() => {
    if (value && isString(value)) {
      const val = value?.split(',');
      setValues(val);
      setTargetKeys(val);
    }
  }, [value]);

  return (
    <>
      <Modal
        open={isModalOpen}
        okText={t('confirm')}
        onOk={() => {
          setValues(targetKeys);
          setIsModalOpen(false);
          onChange?.(targetKeys);
        }}
        width={830}
        closeIcon={
          <CloseOutlined
            className="text-[#000000d9] dark:text-[#ffffff73]"
            style={{ fontSize: 24 }}
          />
        }
        afterClose={() => {
          setTargetKeys(values);
        }}
        destroyOnClose
        className="companySelectModal"
        onCancel={() => setIsModalOpen(false)}
      >
        <Transfer
          dataSource={mockData}
          targetKeys={targetKeys}
          onChange={(newTargetKeys) => {
            setTargetKeys(newTargetKeys);
          }}
          operations={['Add', '']}
          listStyle={{ width: 800 }}
          filterOption={(input: string, item: RecordType) => {
            return item.title?.includes(input);
          }}
          locale={{ searchPlaceholder: 'Search' }}
          oneWay
          showSearch
          showSelectAll={false}
        >
          {({ direction, filteredItems, onItemSelectAll }) => {
            if (direction === 'left') {
              return (
                <div className="companyCountList relative" id="companyCountList">
                  <p className="absolute top-[-40px] left-0">Search:</p>
                  <p className="py-2">
                    {t('available')} {label?.toLocaleLowerCase()}
                  </p>
                  <Checkbox.Group
                    onChange={(val) => {
                      onItemSelectAll(val, 'replace');
                    }}
                    className="w-full"
                  >
                    <List
                      bordered
                      style={{ height: 360, width: '100%', overflow: 'auto' }}
                      dataSource={filteredItems}
                      renderItem={(item) => (
                        <List.Item datatype={item.key}>
                          <Checkbox value={item.key} className="w-full h-[42px]">
                            {item.title}
                          </Checkbox>
                        </List.Item>
                      )}
                    />
                  </Checkbox.Group>
                </div>
              );
            } else {
              return (
                <div className="companyRight pt-[64px]">
                  <p className="pb-2">{t('Selected')}</p>
                  <List
                    bordered
                    style={{ height: 360, width: '100%', overflow: 'auto' }}
                    dataSource={filteredItems}
                    renderItem={(item) => (
                      <List.Item
                        actions={[
                          <Button
                            className="!text-[#0364FF] !border-0 !shadow-none"
                            onClick={() => {
                              const newTargetKeys = targetKeys.filter(
                                (key) => key !== item.key,
                              );
                              setTargetKeys(newTargetKeys.map((key) => key));
                              setTimeout(() => {
                                const liDom: any = document
                                  .getElementById('companyCountList')
                                  ?.querySelectorAll('li');
                                const liArray = Array.from(liDom);
                                const current = liArray?.filter(
                                  (li: any) => li.getAttribute('datatype') === item.key,
                                );
                                if (current && current.length) {
                                  const labelDom = (
                                    current[0] as HTMLElement
                                  ).querySelector('label');
                                  if (
                                    labelDom?.classList.contains(
                                      'ant-checkbox-wrapper-checked',
                                    )
                                  ) {
                                    labelDom?.click?.();
                                  }
                                }
                              }, 0);
                            }}
                            icon={<MinusOutlined />}
                          />,
                        ]}
                      >
                        {item.title}
                      </List.Item>
                    )}
                  />
                </div>
              );
            }
          }}
        </Transfer>
      </Modal>
      <Flex gap="small" align="center">
        {isArray(values) && values.length > 0 ? (
          values?.map((value) => (
            <Tag className="h-[24px] leading-6" key={value}>
              {value}
            </Tag>
          ))
        ) : (
          <Button type="text" disabled className="text-[#00000040]">
            All
          </Button>
        )}
        <Button
          className="!text-[#0364FF] !border-0 !shadow-none"
          onClick={() => setIsModalOpen(true)}
          icon={<PlusOutlined />}
        >
          Select
        </Button>
      </Flex>
    </>
  );
};

export default CustomModalSelect;
